"use strict";

var _regeneratorRuntime = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var operation_retrier_1 = require("operation-retrier");

var logger_1 = require("../logger");

var configuration_1 = require("../configuration");

var FormData = require("isomorphic-form-data");

var log = logger_1.Logger.scope('Network');

var Network =
/*#__PURE__*/
function () {
  function Network(config, transport) {
    _classCallCheck(this, Network);

    this.config = config;
    this.transport = transport;
  }

  _createClass(Network, [{
    key: "backoffConfig",
    value: function backoffConfig() {
      return Object.assign(configuration_1.Configuration.backoffConfigDefault, this.config.backoffConfigOverride);
    }
  }, {
    key: "retryWhenThrottled",
    value: function retryWhenThrottled() {
      if (typeof this.config.retryWhenThrottledOverride !== 'undefined') {
        return this.config.retryWhenThrottledOverride;
      }

      if (typeof configuration_1.Configuration.retryWhenThrottledDefault !== 'undefined') {
        return configuration_1.Configuration.retryWhenThrottledDefault;
      }

      return false;
    }
  }, {
    key: "executeWithRetry",
    value: function executeWithRetry(request) {
      var _this = this;

      var retryWhenThrottled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Promise(function (resolve, reject) {
        var codesToRetryOn = [502, 503, 504];

        if (retryWhenThrottled) {
          codesToRetryOn.push(429);
        }

        var retrier = new operation_retrier_1.Retrier(_this.backoffConfig());
        retrier.on('attempt', function () {
          request().then(function (result) {
            return retrier.succeeded(result);
          }).catch(function (err) {
            if (codesToRetryOn.indexOf(err.status) > -1) {
              retrier.failed(err);
            } else if (err.message === 'Twilsock disconnected') {
              // Ugly hack. We must make a proper exceptions for twilsock
              retrier.failed(err);
            } else {
              // Fatal error
              retrier.removeAllListeners();
              retrier.cancel();
              reject(err);
            }
          });
        });
        retrier.on('succeeded', function (result) {
          resolve(result);
        });
        retrier.on('cancelled', function (err) {
          return reject(err);
        });
        retrier.on('failed', function (err) {
          return reject(err);
        });
        retrier.start();
      });
    }
  }, {
    key: "get",
    value: function get(url) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var headers, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                headers = {
                  'X-Twilio-Token': this.config.token
                };
                log.trace('sending GET request to ', url, ' headers ', headers);
                _context.next = 4;
                return this.executeWithRetry(function () {
                  return _this2.transport.get(url, headers);
                }, this.retryWhenThrottled());

              case 4:
                response = _context.sent;
                log.trace('response', response);
                return _context.abrupt("return", response);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "post",
    value: function post(url, media, contentType) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var headers, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                headers = {
                  'X-Twilio-Token': this.config.token
                };

                if (!(media instanceof FormData) && contentType) {
                  Object.assign(headers, {
                    'Content-Type': contentType
                  });
                }

                log.trace('sending POST request to ', url, ' headers ', headers);
                _context2.prev = 3;
                _context2.next = 6;
                return this.transport.post(url, headers, media);

              case 6:
                response = _context2.sent;
                _context2.next = 17;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](3);

                if (!(_context2.t0 instanceof TypeError)) {
                  _context2.next = 16;
                  break;
                }

                log.trace('got error in post response', _context2.t0);
                throw new TypeError('Posting FormData supported only with browser engine\'s FormData');

              case 16:
                throw _context2.t0;

              case 17:
                log.trace('response', response);
                return _context2.abrupt("return", response);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9]]);
      }));
    }
  }]);

  return Network;
}();

exports.Network = Network;